import { Row, Input, Button, Col, Avatar, message, Checkbox, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import classes from "./Account.module.css";
import { useContext, useState } from "react";
import { updateUserNonAdmin } from "api/userData";
import { useGetIdentity } from "@refinedev/core";
import { UserIdentityData } from "types/props";

export const Accounts: React.FC = () => {
  const { data: user } = useGetIdentity<UserIdentityData>();
  const [firstName, setFirstName] = useState(user?.firstName);
  const [lastName, setLastName] = useState(user?.lastName);
  const [changed, setChanged] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!firstName?.trim() || !lastName?.trim()) {
      message.error("Please enter first and last name");
      return;
    }
    if (firstName.trim().length > 255 || lastName.trim().length > 255) {
      message.error("The First Name and Last Name must be less than 255 characters");
      return;
    }
    setLoading(true);
    if (user) {
      const res = await updateUserNonAdmin(user.id, {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        marketingEmailPreference: user?.marketingEmailPreference
      });
      if (res) {
        // setUser((prev: any) => ({ ...prev, firstName, lastName }));
        setChanged(false);
      }
    }
    setLoading(false);
  };

  return (
    <Row className={classes.jobsContainer}>
      <Row className={classes.container}>
        <Row style={{ width: "100%" }}>
          <Avatar size="large" icon={<UserOutlined />} />
        </Row>
        <Row gutter={24} className={classes.smallInput}>
          <Col span={12} className={classes.nameInput}>
            {" "}
            First Name
            <Input
              onChange={(e) => {
                setFirstName(e.target.value);
                if (e.target.value !== user?.firstName) setChanged(true);
                else setChanged(false);
              }}
              value={firstName}
              className={classes.InputStyle}
              size="large"
            />
          </Col>
          <Col span={12} className={classes.emailInput}>
            Last Name
            <Input
              onChange={(e) => {
                setLastName(e.target.value);
                if (e.target.value !== user?.lastName) setChanged(true);
                else setChanged(false);
              }}
              value={lastName}
              className={classes.InputStyle}
              size="large"
            />
          </Col>
        </Row>
        <Row gutter={24} className={classes.OrganizationInput}>
          <Col span={24} className={classes.organizationName}>
            Email Address
            <Input
              disabled
              value={user?.email}
              className={classes.InputStyle}
              style={{ color: "#f0f0f0" }}
              size="large"
              placeholder=""
            />
          </Col>
        </Row>
        <Row gutter={24} className={classes.OrganizationInput}>
          <Col span={24} className={classes.organizationName}>
            Marketing Email Preference
            <Checkbox
              checked={user?.marketingEmailPreference}
              onChange={(e) => {
                // setUser((prev: any) => ({ ...prev, marketingEmailPreference: e.target.checked }));
              }}>
              <Typography>I would like to receive marketing and newsletter emails</Typography>
            </Checkbox>
          </Col>
        </Row>
        <Row style={{ width: "100%" }}>
          <Button
            loading={loading}
            disabled={!changed || loading}
            className={classes.saveButton}
            onClick={handleSubmit}>
            Save Changes
          </Button>
        </Row>
      </Row>
    </Row>
  );
};
